import { AutoRecipeMonthlyValueMode } from "store/api/generatedApi";

export const latestMonthlyChange = ({
  month,
  changes,
}: {
  month: string;
  changes: Record<string, number>;
}): string | undefined =>
  Object.keys(changes)
    .filter((start) => start <= month)
    .sort()
    .at(-1);

export const monthlyParameterValue = ({
  month,
  changes,
  startingValue,
  mode,
}: {
  month: string;
  changes: Record<string, number>;
  startingValue: unknown;
  mode: AutoRecipeMonthlyValueMode;
}): number | null => {
  const effectiveMonth =
    mode === "carry_forward" ? latestMonthlyChange({ month, changes }) : month;
  const amount =
    effectiveMonth !== undefined && effectiveMonth in changes
      ? changes[effectiveMonth]
      : startingValue;
  return typeof amount === "number" && Number.isFinite(amount) ? amount : null;
};
